/**
 * Policy scope enumeration
 * Note: All Standard policies are Global scope
 */
export enum PolicyScope {
  /**
   * Policy applies to a specific community
   */
  Community = 'Community',

  /**
   * Global policy template that can be applied to multiple communities
   * All Standard policies use this scope
   */
  Global = 'Global',
}
